const ACTIONS = {
    JOIN: 'join',
    JOINED: 'joined',
    DISCONNECTED: 'disconnected',
    CODE_CHANGE: 'code-change',
    SYNC_CODE: 'sync-code',
    LEAVE: 'leave',
    TYPING: 'typing',
    CURSOR_CHANGE: 'cursor-change',
};

module.exports = ACTIONS;
